import { DOCUMENT } from '@angular/common';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  PV_USER_SERVICE,
  PvUserService,
} from '@pv-frontend/pv-shared-services/pv-user-service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from '../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  public clientId = '';

  public constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PV_USER_SERVICE) public pvUserService: PvUserService,
    private router: Router
  ) {}

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    request = request.clone({
      setHeaders: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '-1',
        'X-Download-Options': 'noopen',
        'x-country-id': environment.countryId,
        'x-client-id': environment.clientId,
        'x-project-id': environment.projectId,
        /** Below creds added for testing purpose, will be removed once ready
         * for UAT
         */
        // 'x-client-id': '67846b5f-5008-4e6a-a008-b2350d6b17c3',
        // 'x-project-id': '92f11a3c-1e8f-4210-89f7-5e4949581a2e',
        //DBS creds
        // 'x-client-id': '09fc67f1-b0f7-486e-9ef4-54cb6b74e89f',
        // 'x-project-id': '92f11a3c-1e8f-4210-89f7-5e4949581a2e',

        // 'x-client-id': '9d1207af-b3c1-4096-8cea-8858acf5e27b',
        // 'x-project-id': '94071ce9-7efb-4c62-be72-494a13a4b286',
      },
    });
    const token: string = this.pvUserService.getToken();
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + token,
        },
      });
    } else if (
      request.url.includes('/user/user_cards') ||
      request.url.endsWith('/user')
    ) {
      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + this.pvUserService.getTempToken(),
        },
      });
    } else {
      // this.router.navigate(['login']);
    }

    const userCardId: string = this.pvUserService.getSelectedUserCardId();
    if (userCardId) {
      request = request.clone({
        setHeaders: {
          'x-user-card-id': userCardId,
        },
      });
    }

    return next.handle(request).pipe(
      tap(
        (response: HttpEvent<unknown>) => {
          return response;
        },
        (error: HttpErrorResponse) => {
          return error;
        }
      )
    );
  }
}
